module.exports = __webpack_public_path__ + "static/img/logo4.74e962a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo4.png
// module id = aCAP
// module chunks = 1